//import { createLoweredSymbol, StylesCompileDependency } from '@angular/compiler';
import Style from 'ol/style/Style';
import Text from 'ol/style/Text';
import Icon from 'ol/style/Icon';
import IconOptions from 'ol/style/Icon';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { environment } from '../../../environments/environment';
import IconAnchorUnits from 'ol/style/Icon';
import IconOrigin from 'ol/style/Icon'
import { Circle as CircleStyle, Fill, Stroke } from 'ol/style';

export class OlMapSymbol {
    constructor() {
    }
    public createSymbol(feature: Feature) {
        var offsetSymbol = { "pixelX": 5, "pixelY": 5 };
        var offsetLabel = { "pixelX": 10, "pixelY": 2 };
        var styles = [];
        styles.push(new Style(
            {
                image: this.createIcon(feature.get('iconSymbolURL')),
                text: new Text({
                    'font': 'bold 12px Open sans, Helvetica, Arial, sans-serif',
                    'offsetX': offsetLabel.pixelX,
                    'offsetY': offsetLabel.pixelY,
                    'text': feature.get('id') + ' ' + feature.get('name'),
                    'textAlign': 'left',
                    'overflow': true
                })

            }));
        var greyfill = new Fill({
            color: 'rgba(128,128,128,0.8)'
        });
        var stroke = new Stroke({
            color: '#000',
            width: 0.5
        });

        var marker = new Style({
            image: new CircleStyle({
                fill: greyfill,
                stroke: stroke,
                radius: 4
            })
        });
        styles.push(marker);
        return styles;
    }

    public createselectedSymbol(feature: Feature) {
        var transparentfill = new Fill({
            color: 'rgba(128,128,128,0.0)'
        });
    
        var selectedstroke = new Stroke({
            color: '#FF0',
            width: 4.0
        });
       // var styles = [];
        var marker = new Style({
            image: new CircleStyle({
                fill: transparentfill,
                stroke: selectedstroke,
                radius: 11
            })
        });
      // styles.push(marker);
        return marker;
    }
    

    private createIcon(symbolURL: string) {

        var icon = new Icon({
            anchor: [3, -5],
            offsetOrigin: 'bottom-left'
,            anchorOrigin: 'bottom-left',
            anchorXUnits: 'pixels',
            anchorYUnits: 'pixels',
            scale: 1.5,
           // size:[30,90],
            //imgSize: [20, 60],
            src: symbolURL
        });
        return icon;

    }    
}